import { render, staticRenderFns } from "./action-button-block.vue?vue&type=template&id=adaf8e0c&scoped=true"
import script from "./action-button-block.vue?vue&type=script&lang=js"
export * from "./action-button-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaf8e0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adaf8e0c')) {
      api.createRecord('adaf8e0c', component.options)
    } else {
      api.reload('adaf8e0c', component.options)
    }
    module.hot.accept("./action-button-block.vue?vue&type=template&id=adaf8e0c&scoped=true", function () {
      api.rerender('adaf8e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/components/setting-blocks/components/action-button-block.vue"
export default component.exports